import React from 'react';
import { Link } from 'gatsby';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../components/layouts/Layout';
import SEO from '../components/seo';
import promotion from '../../promotion_config';

import desktopHero from '../components/home/images/desktop-hero.png';
import mobile_hero from '../components/home/images/mobile-hero.png';

import '../components/home/style.scss';

export const Home = ({ user, notification, actions }) => {
    return (
        <Layout user={user} notification={notification} actions={actions}>
            <SEO title="Home" />
            <HomeInner />
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);

export const HomeInner = () => {
    return (
        <div className="content-container home">
            <div className="row">
                <div className="col-xs-12">
                    <div
                        className="hidden-xs hidden-sm"
                    >
                        <Link to="enter">
                            <div className="container-fluid">
                                <div className="col-md-12">
                                    <div
                                        className="row"
                                    >
                                        <img alt="Enter For a Chance to Win 50 $500 prizes for 12 Weeks! Including a Final Prize of $200,000! Enter Now!"
                                            className="desktop-hero"
                                            src={desktopHero}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Link>
                        <div className="home-panel">
                            <h2 className="text-center">How to Play</h2>
                            <p className="text-center">
                                All non-winning Twelve Weeks of Holiday Winnings
                                2nd Chance Promotion Instant Tickets from the Illinois
                                Lottery are eligible to be entered for a chance to win
                                up to $200,000.
                            </p>
                            <p className="text-center">
                                To enter,{' '}
                                <a
                                    href={promotion.registerLink}
                                    target="_blank"
                                >
                                    CREATE
                                </a>{' '}
                                a free account,{' '}
                                <a href={promotion.loginLink}>LOG IN</a> at any time between September 29, 2023 and January 16, 2024
                                and enter your eligible tickets in the second chance drawing.
                            </p>
                        </div>
                    </div>
                    <div className="visible-xs visible-sm">
                        <Link to="enter">
                            <img
                                src={mobile_hero}
                                alt="Enter For a Chance to Win 50 $500 prizes for 12 Weeks! Including a Final Prize of $200,000! Enter Now!"
                                className="full-width center-block"
                            />
                        </Link>
                        <div className="sr-only">
                            <h2>
                                Enter for a chance to win $200,000 in Cash Prizes
                            </h2>
                            <Link className="enter-now-link" to="/enter">
                                Enter Now
                            </Link>
                        </div>
                        <div className="home-panel">
                            <h2 className="text-center">How to Play</h2>
                            <p className="text-center">
                                All non-winning Twelve Weeks of Holiday Winnings
                                2nd Chance Promotion Instant Tickets from the Illinois
                                Lottery are eligible to be entered for a chance to win
                                up to $200,000.
                            </p>
                            <p className="text-center">
                                To enter,{' '}
                                <a
                                    href={promotion.registerLink}
                                    target="_blank"
                                >
                                    CREATE
                                </a>{' '}
                                a free account,{' '}
                                <a href={promotion.loginLink}>LOG IN</a> at any time between September 29, 2023 and January 16, 2024
                                and enter your eligible tickets in the second chance drawing.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
